import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class ErrorService {
  private currentError = new Subject();

  handleError(err: any): Observable<any> {
    return Observable.throw(err.json() || 'Server error');
  }

  getError() {
    return this.currentError.asObservable();
  }

  clearError() {
    this.currentError = new Subject();
  }

  closeError() {
    this.currentError.complete();
  }

  setError(err) {
    let jerr = {};

    try {
      jerr = err.json();
    } catch (e) {
      jerr = {code: err['status'], message: err['_body']};
    }

    this.currentError.next(jerr);

    return Observable.throw(jerr);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/errors/error.service.ts